module.exports = __webpack_public_path__ + "static/media/mini-headset-mic-2.626f92a8.jpg";